<template>
  <el-card>
    <el-form class="global-form" inline ref="searchsearchForm" :model="searchForm">
      <el-form-item prop="sceneryName">
        <el-input v-model="searchForm.sceneryName" placeholder="请输入景点名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectId">
        <el-select v-model="searchForm.projectId" placeholder="请选择公园名称" clearable filterable>
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isNetRed">
        <el-select v-model="searchForm.isNetRed" placeholder="请选择是否网红景点" clearable>
          <el-option label="否" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='onAdd' type="primary" v-if="$ButtonShow('SCENERY_ADD_01')">添加景点</el-button>
    <el-button class="mb20" type="primary" @click="showRoute">推荐路线</el-button>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="景点名称" show-overflow-tooltip prop="sceneryName"></el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="是否网红景点" show-overflow-tooltip prop="isNetRed">
        <template v-slot="{ row }">
          {{ row.isNetRed === '1' ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="编号" show-overflow-tooltip prop="sceneryCode"></el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row)">查看</el-button>
          <el-button type="text" @click="onUpdate(row)" v-if="$ButtonShow('SCENERY_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onDelete(row.sceneryId)" v-if="$ButtonShow('SCENERY_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>

    <el-dialog title="推荐路线" width="800px" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="formData" :rules="rules">
        <el-table class="global-table" :data="routeList">
          <el-table-column width="180" label="路线名称" prop="routeName">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{ row.routeName }}</span>
              <el-form-item v-else prop="routeName">
                <el-input v-model="formData.routeName" maxlength="15" placeholder="不超过15字"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="所属公园" prop="projectId">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{ row.projectName }}</span>
              <el-form-item v-else prop="projectId">
                <el-select v-model="formData.projectId" placeholder="选择公园" @change="loadScenery">
                  <el-option v-for="(item, index) of parkList" :value="item.projectId" :label="item.projectName"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="路线景点" show-overflow-tooltip prop="sceneryCodes">
            <template v-slot="{ row }">
              <span class="scenery-name" v-if="!row.isEdit">{{ row.sceneryNames.join() }}</span>
              <el-form-item v-else prop="sceneryCodes">
                <el-select class="scenery-select" filterable clearable v-model="formData.sceneryCodes" multiple
                  placeholder="请按路线景点顺序依次选择">
                  <el-option v-for="(item, index) of sceneryList" :value="item.sceneryCode" :label="item.sceneryName"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100px" fixed="right">
            <template v-slot="{ row }">
              <template v-if="row.isEdit">
                <el-button type="text" @click="saveRoute">保存</el-button>
                <el-button type="text" @click="cancelRoute(row)">取消</el-button>
              </template>
              <template v-else>
                <el-button type="text" @click="editRoute(row)" v-if="$ButtonShow('PTR_EDT_01')">编辑</el-button>
                <el-button type="text" @click="deleteRoute(row)" v-if="$ButtonShow('PTR_DEL_01')">删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-button type="text" @click="addRoute" v-if="$ButtonShow('PTR_ADD_01')">新增路线</el-button>
    </el-dialog>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Scenicspot',
  mixins: [keepAlive],
  data() {
    return {
      searchForm: {
        projectId: '',
        sceneryName: '',
        isNetRed: ''
      },
      dialogVisible: false,
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      parkList: [],
      sceneryList: [],
      routeList: [],
      formData: {
        projectId: '', // 公园id
        routeName: '', // 线路名称
        sceneryCodes: []
      },
      rules: {
        projectId: [{ required: true, message: '请选择所属公园', trigger: ['blur', 'change'] }], // 公园id
        routeName: [{ required: true, message: '请输入路线名称', trigger: ['blur', 'change'] }], // 线路名称
        sceneryCodes: [{ required: true, type: 'array', message: '请选择路线景点', trigger: ['blur', 'change'] }]
      }
    }
  },
  created() {
    console.log(this.$route);
    this.loadData()
    this.getPark()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    loadScenery(projectId) {
      this.$axios.get(this.$apis.tourist.selectSceneryByList, {
        projectId
      }).then(res => {
        this.sceneryList = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectSceneryByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/scenicspot/add')
    },
    onUpdate(item) {
      this.$router.push({
        name: 'scenicspotUpdate',
        params: { sceneryId: item.sceneryId },
        query: {
          projectId: item.projectId
        }
      })
    },
    onDetail(item) {
      this.$router.push({
        name: 'scenicspotDetail',
        params: { sceneryId: item.sceneryId },
        query: {
          projectId: item.projectId
        }
      })
    },
    onDelete(id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteScenery, {
          sceneryId: id
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData()
        })
      })
    },
    showRoute() {
      this.loadRoute()
      this.dialogVisible = true
    },
    editRoute(row) {
      this.routeList.forEach(item => {
        item.isEdit = false
      })
      this.formData = JSON.parse(JSON.stringify(row))
      this.loadScenery(row.projectId)
      row.isEdit = true
    },
    cancelRoute(row) {
      if (row.routeNumber) {
        row.isEdit = false
      } else {
        this.routeList.pop()
      }
    },
    addRoute() {
      this.formData = {
        projectId: '', // 公园id
        routeName: '', // 线路名称
        sceneryCodes: []
      }
      this.routeList.push({
        isEdit: true,
        projectId: '', // 公园id
        routeName: '', // 线路名称
        sceneryCodes: []
      })
    },
    loadRoute() {
      this.$axios.get(this.$apis.tourist.selectAllTouringRoute).then(res => {
        this.routeList = res.map(item => {
          item.isEdit = false
          return item
        })
      })
    },
    saveRoute() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.tourist.addTouringRoute
        if (this.formData.routeNumber) {
          url = this.$apis.tourist.updateTouringRoute
        }
        this.$axios.post(url, this.formData).then(res => {
          this.loadRoute()
        })
      })
    },
    deleteRoute(row) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteTouringRoute, {
          routeNumber: row.routeNumber,
          projectId: row.projectId
        }).then(() => {
          this.$message({ message: '删除成功', type: 'success' })
          this.loadRoute()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.scenery-name {
  white-space: nowrap;
}

.scenery-select {
  width: 100%;
}
</style>
